(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    // A link to #accordion-<heading> opens that row and brings it into view.
  // The short delay lets a closing drawer return focus first.
  (() => {
    const openFromHash = () => {
      const id = decodeURIComponent(window.location.hash.slice(1));
      if (!id.startsWith('accordion-')) return;
      const details = document.getElementById(id);
      if (!(details instanceof HTMLDetailsElement)) return;
      setTimeout(() => {
        details.open = true;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        details.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }, 350);
    };
    window.addEventListener('hashchange', openFromHash);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFromHash);
    else openFromHash();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('klaviyo-signup')) {
    customElements.define(
      'klaviyo-signup',
      class extends HTMLElement {
        connectedCallback() {
          const form = this.querySelector('form');
          form?.addEventListener('submit', (event) => {
            if (!window.taelKlaviyo) return; // helper not loaded: Shopify handles the form as before
            event.preventDefault();
            window.taelKlaviyo.submitForm(form, { source: this.dataset.source, success: this.dataset.success });
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["group"] && !Shopify.designMode) return;
  try {
    class CarouselGroup extends HTMLElement {
    connectedCallback() {
      const controls = this.nextElementSibling;
      this.prevButton = controls && controls.querySelector('.group-block__carousel-arrow--prev');
      this.nextButton = controls && controls.querySelector('.group-block__carousel-arrow--next');

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByItem(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByItem(1));

      if (this.prevButton || this.nextButton) {
        this.addEventListener('scroll', () => this.updateControls(), { passive: true });
        window.addEventListener('resize', () => this.updateControls());
        this.updateControls();
      }

      if (this.dataset.autoplay === 'true') this.setupAutoplay();
    }

    scrollByItem(direction) {
      const item = this.firstElementChild;
      const gap = parseFloat(getComputedStyle(this).columnGap) || 16;
      const amount = item ? item.getBoundingClientRect().width + gap : this.clientWidth * 0.8;
      this.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    setupAutoplay() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const speed = Math.max(parseFloat(this.dataset.autoplaySpeed) || 4, 0.5) * 1000;
      let timer = null;
      let stoppedByUser = false;

      const tick = () => {
        const maxScroll = this.scrollWidth - this.clientWidth;
        if (this.scrollLeft >= maxScroll - 4) {
          this.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.scrollByItem(1);
        }
      };

      const start = () => {
        if (timer || stoppedByUser) return;
        timer = setInterval(tick, speed);
      };

      const stop = () => {
        clearInterval(timer);
        timer = null;
      };

      const stopForGood = () => {
        stoppedByUser = true;
        stop();
      };

      this.addEventListener('mouseenter', stop);
      this.addEventListener('mouseleave', start);
      this.addEventListener('pointerdown', stopForGood, { passive: true });
      if (this.prevButton) this.prevButton.addEventListener('click', stopForGood);
      if (this.nextButton) this.nextButton.addEventListener('click', stopForGood);

      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => (entry.isIntersecting ? start() : stop()));
        },
        { threshold: 0.4 }
      ).observe(this);
    }

    updateControls() {
      const maxScroll = this.scrollWidth - this.clientWidth;
      if (this.prevButton) this.prevButton.disabled = this.scrollLeft <= 4;
      if (this.nextButton) this.nextButton.disabled = this.scrollLeft >= maxScroll - 4;
    }
  }

  if (!customElements.get('carousel-group')) {
    customElements.define('carousel-group', CarouselGroup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review-stars"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-review-stars]');
    const href = link?.getAttribute('href');
    if (!href?.startsWith('#')) return;
    const target =
      document.querySelector(href) ||
      document.querySelector('.jdgm-review-widget, .jdgm-widget.jdgm-review-widget, [id*="judgeme"]');
    if (!target) return;

    event.preventDefault();
    const header = document.querySelector('#header-component, .header');
    target.style.scrollMarginTop = `${(header?.offsetHeight || 0) + 16}px`;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

})();
